import * as _ from "lodash-es";
import { Component, HostListener, OnInit, ChangeDetectionStrategy, inject, output } from "@angular/core";
import { FormBuilder, FormGroup, Validators, FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { User } from "src/app/models/users.model";
import { AlertService } from "src/app/services/alert.service";
import { AuthService } from "src/app/services/auth.service";
import { RxReactiveFormsModule } from "@rxweb/reactive-form-validators";
import { MatFormField, MatLabel, MatError } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { NgClass } from "@angular/common";
import { MatIcon } from "@angular/material/icon";
import { MatButton } from "@angular/material/button";

@Component({
    selector: "app-login-form",
    templateUrl: "./login.form.html",
    styleUrls: ["./login.form.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule, RxReactiveFormsModule, MatFormField, MatLabel, MatInput, NgClass, MatError, MatIcon, MatButton, TranslatePipe]
})
export class LoginForm implements OnInit {
    protected router = inject(Router);
    protected formBuilder = inject(FormBuilder);
    protected alertService = inject(AlertService);
    protected authService = inject(AuthService);
    protected route = inject(ActivatedRoute);
    protected translate = inject(TranslateService);

    readonly isFormLoading = output<boolean>();

    form: FormGroup;
    isLoading = false;
    returnUrl: string | null = null;

    get controls() {
        return this.form.controls;
    }
    get currentUser(): User | null {
        return this.authService.user;
    }
    resetPassword: string | null = null;
    prId: string | null = null;
    userId: string | null = null;

    @HostListener("keydown.enter")
    onEnterKey() {
        this.onSubmit();
    }

    constructor() {
        this.form = this.formBuilder.group({
            username: new FormControl("", Validators.required),
            password: new FormControl("", Validators.required)
        });
        this.userId = this.route.snapshot.queryParamMap.get("userId");
        this.resetPassword = this.route.snapshot.queryParamMap.get("resetPassword");
        this.prId = this.route.snapshot.queryParamMap.get("prId");
        this.returnUrl = this.route.snapshot.queryParamMap.get("returnUrl");
    }

    ngOnInit() {}

    onSubmit() {
        let username: string = this.controls.username.value.trim(),
            password: string = this.controls.password.value.trim();
        // $socketId: Id = this.io.socket.id;
        this.isLoading = true;
        this.isFormLoading.emit(true);

        const result = this.authService
            .login(username, password /*{ $socketId }*/)
            .then(result => {
                this.isLoading = false;
                this.isFormLoading.emit(false);
                // Switch to user's language preference after login
                if (this.authService.user?.lang) {
                    this.translate.use(this.authService.user.lang);
                }
                this.alertService.success(this.translate.instant("WELCOME") + " " + this.currentUser?.fullname);
                // using a force reload so the socket service can update his auth token
                setTimeout(() => {
                    if (this.resetPassword && this.userId) {
                        window.location.href = `/#/user/reset-password/${this.userId}/1`;
                    } else if (this.prId) {
                        window.location.href = `/#/splitview/${this.prId}`;
                    } else if (this.returnUrl) {
                        window.location.href = `/#${decodeURI(this.returnUrl)}`;
                    } else {
                        window.location.href = "/";
                    }
                }, 1000);
            })
            .catch(e => {
                this.isLoading = false;
                this.isFormLoading.emit(false);
                this.alertService.error(_.isObject(e) ? (e as any).message || "Unknown error" : e);
            });
    }

    isDisabled() {
        return this.form.invalid;
    }

    onForgotPassword() {
        this.router.navigate(["/reset-password"]);
    }
}
